import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/User';
import { AuthService } from '../../../services/auth.service';
import { MissionService } from '../../../services/mission.service';
import { FormBuilder } from '@angular/forms';
import moment from 'moment';
import { CandidatesApplied, Mission } from '../../../models/Mission';
import { CandidatStatusOnMission } from '../../../shared/utils/enums';
import { DetailsComponent } from '../candidatures/details/details.component';
import { MatDialog } from '@angular/material/dialog';
import { EstablishmentService } from '../../../services/establishment.service';
import { DocuSignService } from '../../../services/docu-sign.service';
import { MissionDetailsComponent } from '../missions/encour-component/mission-details/mission-details.component';

@Component({
  selector: 'app-accueil-etablissement',
  templateUrl: './accueil-etablissement.component.html',
  styleUrl: './accueil-etablissement.component.scss',
})
export class AccueilEtablissementComponent implements OnInit {
  statsArray = [
    { id: 1, label: 'Missions publiées', value: '0', icon: 'clock' },
    { id: 2, label: 'Missions en cours', value: '0', icon: 'play' },
    {
      id: 3,
      label: 'Missions terminées',
      value: '0',
      icon: 'check-circle-action',
    },
  ];

  weekMissions: Mission[] = [];
  candidatureList: any[] = [];
  missionsList: any[] = [];
  contratList: any[] = [];
  candidatureLoading = false;
  acceptLoading = false;
  loadingStat = false;

  user: User | null;
  formFilter = this.fb.group({
    adresseId: null,
    endDate: moment(new Date()).add(7, 'days'),
    missionTitle: [''],
    page: 0,
    size: 10,
    startDate: new Date(),
    statusOfCandidatOnMission: [[]],
  });
  formContratFilter = this.fb.group({
    adresseId: null,
    endDate: '',
    missionTitle: [''],
    page: 0,
    size: 10,
    startDate: '',
    statusOfCandidatOnMission: [[CandidatStatusOnMission.ACCEPTED]],
  });
  loadingContract = false;
  constructor(
    private auth: AuthService,
    private missionService: MissionService,
    private fb: FormBuilder,
    private establishmentService: EstablishmentService,
    private docuSign: DocuSignService,
    private dialog: MatDialog
  ) {
    try {
      this.user = this.auth.user;
    } catch (e) {}
  }

  ngOnInit(): void {
    if (this.auth.id === 0)
    {
      this.auth.id == this.user?.collary_id;
    }
    this.getMissions();
    this.fetchCandidature();
    this.getContratList();
    this.getStats();
  }

  getStats() {
    this.loadingStat = true;
    this.establishmentService.getEstablishmentStats(this.auth.id).subscribe({
      next: (value) => {
        this.statsArray[0].value = value.published;
        this.statsArray[1].value = value.inProgress;
        this.statsArray[2].value = value.finished;
        this.loadingStat = false;
      },
    });
  }
  fetchCandidature() {
    this.candidatureLoading = true;

    const body = {
      adresseId: null,
      endDate: '',
      missionTitle: '',
      page: 0,
      size: 100,
      startDate: '',
      statusOfCandidatOnMission: [],
    };
    
    this.missionService
      .getMissionsByEstablishmentId(body, this.auth.id!)
      .subscribe({
        next: ({ content, totalItems }) => {
          this.candidatureList = [];
          this.missionsList = content;
          for (const mission of content) {
            if (mission.candidatesApplied) {
              mission.candidatesApplied.forEach(
                (candidature: CandidatesApplied) => {
                  const item = {
                    candidature,
                    startdate: mission.startdate,
                    site: mission.adresseDto?.name,
                    enddate: mission.enddate,
                    typeContrat: mission.typecontat,
                    missionTitle: mission.missionTitle,
                    typePoste: mission.typePoste,
                    address: mission.adresseDto.adress,
                    isurgent: mission.isurgent,
                    serviceAffectationsName: mission.serviceAffectationsName,
                    secteur: mission.typeSecteur,
                    compensationproposednet: mission.compensationproposednet,
                    missionStatus: mission.missionStatus,
                    id: mission.id,
                  };
                  if (
                    item.candidature.statusOfCandidatOnMission ===
                    CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION
                  ) {
                    this.candidatureList.push(item);
                  }
                }
              );
            }
            // for (const candidature of content?.candidatesApplied) {
            //
            // }
          }

          this.candidatureLoading = false;
        },
        error: (err) => {
          this.candidatureLoading = false;
        },
      });
  }
  getMissions() {
    this.missionService
      .getMissionsByEstablishmentId(this.formFilter.value, this.auth.id!)
      .subscribe({
        next: ({ content }) => {
          this.weekMissions = content;
        },
      });
  }

  getContratList() {
    this.loadingContract = true;
    this.missionService
      .getMissionsByEstablishmentId(this.formContratFilter.value, this.auth.id!)
      .subscribe({
        next: ({ content }) => {
          this.contratList = content
            .filter((b: any) => b.candidatesApplied.length > 0)
            .map((a: any) => {
              if (a.candidatesApplied && a.candidatesApplied.length) {
                for (let candidate of a.candidatesApplied) {
                  if (candidate) {
                    return {
                      ...candidate,
                      ...a,
                    };
                  }
                }
                // return a.candidatesApplied
              }
            });
          this.loadingContract = false;
        },
      });
  }

  acceptCandidature(data: any) {
    this.acceptLoading = true;
    const body = {
      candidatId: data.candidature.candidatId,
      missionId: data.id,
      status: CandidatStatusOnMission.ACCEPTED,
    };
    this.missionService.updateCandidateStatus(body).subscribe({
      next: () => {
        this.acceptLoading = false;
        this.fetchCandidature();
      },
      error: () => {
        this.acceptLoading = false;
      },
    });
  }

  handleFullRowClick = (row: any) => {
    this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
      // animation: { to: "left" }
    });
  };

  generateContract(item: any) {
    this.establishmentService
      .generateContract(item.candidatId, item.id, this.auth.id!)
      .subscribe({
        next: () => {
          this.establishmentService
            .generateContractPreview(item.candidatId, item.id, this.auth.id!)
            .subscribe((value) => {
              // window.open(value, "_blank");
              this.docuSign.openDocuSignDialog(value);
            });
        },
        error: (err) => {},
      });
  }

  openMissionDetails(item: any) {
    this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: item,
    });
  }
  handleRowClick = (row: any) => {
    this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
    });
  };
}
